import { render } from "./ResetPassword.vue?vue&type=template&id=86405ae6&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-86405ae6"

export default script